import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { NullQ } from "@pdfking/structs"

import { IDMixin } from "../../mixins/IDMixin"
import { DjInput } from "../fields/DjInput"
import { DjTextarea } from "../fields/DjTextarea"
import { FieldMixin } from "../mixins/FieldMixin"
import { AtomFormMixin } from "../mixins/FormMixin"
import { NodeMixin } from "../mixins/NodeMixin"
import { dom_id } from "./DomId"
import { FieldShell } from "./FieldShell"
import { ViewMixin } from "./ViewMixin"

export const AtomField = CreateRenderFunction({
  mixins: [NodeMixin, FieldMixin, IDMixin, ViewMixin, AtomFormMixin] as const,
  render() {
    const node = this.node!
    const id = dom_id(this)
    const shared = {
      disabled: this.disabled,
      dom_id: id,
      error: node.error,
      input: String(node.input ?? ""),
      oncommit: node.validate,
    }
    return (
      <FieldShell
        cell={this.cell}
        className={this.className}
        error={node.error}
        field_key={this.field_key}
        hide_labels={this.hide_labels}
        path={id}
      >
        {this.field_key === "notes" ? (
          <DjTextarea {...shared} />
        ) : (
          <DjInput
            {...shared}
            placeholder={NullQ(node.value) ? undefined : node.format(node.value)}
            suggestions={node.suggestions ?? undefined}
          />
        )}
      </FieldShell>
    )
  },
})
